import List from "./List";
import Annotation from "./Annotation";

export default {
  List,
  Annotation
};
